import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

import options from '~/formulate.config.js'

Vue.use(VueFormulate, options)
